export const ROSTER_REQUEST = 'ROSTER_REQUEST';
export const ROSTER_SUCCESS = 'ROSTER_SUCCESS';
export const ROSTER_ERROR = 'ROSTER_ERROR';
export const ROSTERS_CLEAR = 'ROSTERS_CLEAR';
